module.exports = __webpack_public_path__ + "static/media/sneakerAnimation.b859ae59.mp4";